import { getRequiredElement } from "../../Shared/Utilities/attributes";

const form = getRequiredElement<HTMLFormElement>(
  document,
  "#search-page-form",
  "Search page form missing"
);

// Submit the form whenever sorting or a filter is updated
const inputs = form.querySelectorAll<HTMLElement>("select, input[type='checkbox']");

inputs.forEach(input => {
  input.addEventListener("change", async _ => {
    form.requestSubmit();
  });
});
